/* eslint-disable camelcase */
import { Currency } from '@pegasus/translation';
export const isGA4Event = (event) => {
    return typeof event === 'string' && event.startsWith('GA4-');
};
export const isPageViewEvent = (event) => {
    return event === 'GA4-page_view';
};
export const isEventWithCurrency = (event) => {
    return [
        'GA4-EEC-remove_from_cart',
        'GA4-EEC-add_to_cart',
        'GA4-EEC-begin_checkout',
        'GA4-EEC-purchase',
        'GA4-EEC-view_cart',
        'GA4-EEC-view_item',
    ].includes(event);
};
export const isConsentUpdateEvent = (event) => {
    if (Array.isArray(event)) {
        return event[0] === 'consent' && event[1] === 'update';
    }
    if (event['0'] && event['1']) {
        return event['0'] === 'consent' && event['1'] === 'update';
    }
    return false;
};
export const matchConsentUpdateEvent = ({ event }) => {
    return isConsentUpdateEvent(event);
};
export const matchGA4PageViewEvent = ({ event, event_name, }) => {
    return isPageViewEvent(event) && event_name === 'page_view';
};
export const transformCurrencyCode = (currency) => {
    return currency === Currency.RON ? 'RON' : currency;
};
export const RecommendationType = {
    browseColor: 'color_recommendation',
    browseCategory: 'category_recommendation',
    browseBrand: 'brand_recommendation',
    'Reco PDP': 'article_recommendation',
    '3': 'article_recommendation',
};
export const getRecommendationType = (type) => {
    if (!type || type === '0') {
        return null;
    }
    return RecommendationType[type] || type;
};
//# sourceMappingURL=utils.js.map